export default __webpack_public_path__ + "static/media/streaks 20.a5947b74.svg";